import type { BillingCommandFamily } from "./catalog";

export const BILLING_COMMAND_RUNTIME_CONTRACT = "billing_command_runtime_v1";
export const BILLING_COMMAND_INGRESS_CONTRACT = "billing_command_ingress_v1";

export type BillingCommandRuntimeContract =
  typeof BILLING_COMMAND_RUNTIME_CONTRACT;

export type BillingCommandIngressContract =
  typeof BILLING_COMMAND_INGRESS_CONTRACT;

export const BILLING_COMMAND_RUNTIME_PARENT_STATE_IDS = {
  runtimeStartTask: "RuntimeStartTask",
  buildRuntimeEnvelope: "BuildRuntimeEnvelope",
  commandFamilyRouter: "CommandFamilyRouter",
  reconciliationDriftIntentBridge: "ReconciliationDriftIntentBridge",
  providerOutcomeGateTask: "ProviderOutcomeGateTask",
  providerOutcomeGateChoice: "ProviderOutcomeGateChoice",
  shopifyCapApprovalTask: "ShopifyCapApprovalTask",
} as const;

export const BILLING_COMMAND_INGRESS_PARENT_STATE_IDS = {
  ingressRoutingTask: "IngressRoutingTask",
  buildDispatcherEnvelope: "BuildDispatcherEnvelope",
  routedNeedsSyncChoice: "RoutedNeedsSyncChoice",
  ingressOutcomeChoice: "IngressOutcomeChoice",
  dispatchOutcomeChoice: "DispatchOutcomeChoice",
  startRuntimeExecution: "StartRuntimeExecution",
} as const;

export const BILLING_COMMAND_RUNTIME_COMMAND_FAMILY_CHOICES: readonly BillingCommandFamily[] =
  [
    "reconciliation",
    "repair_sweep",
    "create_reactivate",
    "trial_lifecycle",
    "product_set_change",
    "pause_cancel_release",
    "subscription_lifecycle",
    "scheduled_wakeup",
    "provider_confirmation",
    "shopify_cap_approval",
  ] as const;
